import TranslationProvider from '@/provider/translations.js'
import { attr_amount, attr_endDate, attr_startDate } from '@/services/campaignService.js'
import { formatDateLocale } from '@/libs/utils/date.js'

export const addDelegatedLabel = value => {
  return `<b>${TranslationProvider.getTrans('app.delegato')}</b>: ${value}`
}

export const formatLabel = (name, value) => {

  switch (name) {
    case 'addDelegatedLabel':
      return addDelegatedLabel(value)
  }

  return value
}

export const formatCampaignAttribute = (attribute, value) => {
  if (!attribute || !value) {
    return ''
  }

  if (attribute === attr_amount) {
    return parseFloat(value).toFixed(2)
  } else if ([attr_startDate, attr_endDate].includes(attribute)) {
    return formatDateLocale(value, false)
  }

  return value
}
